import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableListerCell from '../tablecell';
import HierarchyTogglerCell from './hierarchyToggler';

function TableCatListerRow({
  row, columns, onFocus, selected, tabIndex, onContextMenu, permissions, actions, isOpened,
}) {
  const onClickHandler = useCallback(
    (e) => {
      onFocus(e, row.id);
    },
    [onFocus, row.id],
  );
  return (
    <TableRow
      data-id={row.id}
      hover
      selected={selected}
      onClick={onClickHandler}
      tabIndex={tabIndex}
      onDoubleClick={(e) => actions.onRowDoubleClick(e, row.id)}
    >
      {permissions.canHierarchy && (
        <HierarchyTogglerCell
          // isFolder={isFolder}
          // canBeOpened={canBeOpened}
          onClick={(e) => actions.onToggle(e, row.id)}
          opened={isOpened}
          level={row.level}
        />
      )}
      {/* eslint-disable-next-line array-callback-return,consistent-return */}
      {columns.map((c) => (
        <TableListerCell
          key={c.key}
          value={row[c.key]}
          variants={c.variants}
          type={c.type}
          choices={c.choices}
          onContextMenu={(e) => onContextMenu(e, row.id)}
        />
      ))}
    </TableRow>

  );
}

TableCatListerRow.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.oneOf([
      'string', 'email', 'url', 'integer', 'float', 'decimal', 'choice', 'date', 'datetime', 'nested object', 'boolean', 'field',
    ]),
  })).isRequired,
  row: PropTypes.shape({
    id: PropTypes.number.isRequired,
    level: PropTypes.number,
  }).isRequired,
  onFocus: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  tabIndex: PropTypes.number.isRequired,
  onContextMenu: PropTypes.func.isRequired,
  permissions: PropTypes.shape({
    canHierarchy: PropTypes.bool,
    foldersUsed: PropTypes.bool,
  }).isRequired,
  actions: PropTypes.shape({
    onToggle: PropTypes.func.isRequired,
    enEdit: PropTypes.func,
    onRowDoubleClick: PropTypes.func,
  }).isRequired,
  isOpened: PropTypes.bool,
};

TableCatListerRow.defaultProps = {
  selected: false,
  isOpened: false,
};

export default memo(TableCatListerRow);
